import * as React from "react"


export default function pageTypeColumn() {
    return {
        name: 'pageCategory',
        label: 'Mono/Multi Brand',
        options: {
            filter: false,
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRender: value => value
        }
    }
}